<template>
  <article id="requirements-wrapper">
    <header>
      <h1 id="requirements-title">
        REQUIREMENTS:
      </h1>
    </header>
    <ul id="list">
      <li>
        <img src="/fonts/icons/sgz_bullet.svg" class="sgz-bullet" /> DAYZ COPY
        ON STEAM
      </li>
      <li>
        <img src="/fonts/icons/sgz_bullet.svg" class="sgz-bullet" />
        WINDOWS PC<br />
        <span style="display: inline-block;margin-left: 35px"
          >(MINIMUM: Windows 7/8.1 64-bit; Intel Core i5-4430; 8 GB RAM; 25 GB
          available space)</span
        >
      </li>
      <li>
        <img src="/fonts/icons/sgz_bullet.svg" class="sgz-bullet" /> STABLE
        INTERNET CONNECTION
      </li>
    </ul>
  </article>
</template>

<script>
export default {
  name: "SgzRequirements"
};
</script>

<style lang="scss" scoped>
#requirements-wrapper {
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0) 0%,
    #000000 16%,
    #414c57 100%
  );
  border-radius: 18px;
  padding: 2em 4em 4em;

  @media (max-width: 600px) {
    padding: 1.5em;
  }
}

#requirements-title {
  @media (max-width: 600px) {
    font-size: 1.8em;
  }

  @media (max-width: 500px) {
    font-size: 1.5em;
  }
}

#list {
  margin-top: 3em;
  list-style: none;
  margin-left: 0;
  padding: 0;

  li {
    margin-bottom: 3em;
    font-size: 16px;

    @media (max-width: 600px) {
      font-size: 14px;
    }

    @media (max-width: 500px) {
      font-size: 12px;
    }

    .sgz-bullet {
      margin-top: -1px;
      margin-right: 1em;
    }
  }
}
</style>
